import * as React from "react";
import FilterInput from "../core/FilterInput";
import RoleBadges from "../core/RoleBadges";

interface IProps {
  employees: INormalizedObject[];
  showRoles?: boolean;
}

class EmployeeList extends React.Component<IProps> {
  state = { filter: "" };

  render() {
    const { employees } = this.props;
    const { filter } = this.state;

    const list = employees
      .filter(u => {
        if (!filter) return true;
        const filterChars = filter.toUpperCase();
        const nameMatches = u.name.toUpperCase().includes(filterChars);
        const emailMatches = u.email.toUpperCase().includes(filterChars);
        return nameMatches || emailMatches;
      })
      .map(u => (
        <tr key={u.id}>
          <td>
            <a href={Routes.employee_path(u.id)}>{u.name}</a>
          </td>
          <td>{u.email}</td>
          <td>
            {this.props.showRoles && (
              <RoleBadges
                roles={u.roles}
                filter={["user"]}
                filterOnMultiple={true}
              />
            )}
          </td>
        </tr>
      ));

    return (
      <div>
        <FilterInput
          placeholder="Filter Users"
          value={filter}
          onChange={filter => this.setState({ filter })}
        />
        <table className="table table-striped">
          <thead>
            <tr>
              <th>Name</th>
              <th>Email</th>
              {this.props.showRoles && <th>Roles</th>}
            </tr>
          </thead>
          <tbody>{list}</tbody>
        </table>
      </div>
    );
  }
}

export default EmployeeList;



// WEBPACK FOOTER //
// ./app/javascript/components/employee/EmployeeList.tsx